import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from "reactstrap";
import axios from "axios";
import { API_MAI_FALI } from "../utils";
import { logoutUser } from "../actions/AuthAction";

const PelaporanKegiatan = (props) => {
  const [formData, setFormData] = useState({
    ormas_id: "",
    nama_kegiatan: "",
    bidang_kegiatan: "",
    sumber_anggaran: "",
    deskripsi_kegiatan: "",
    periode_kegiatan: "",
    lokasi_kegiatan: "",
    jumlah_peserta: "",
    anggaran_kegiatan: "",
    tanggal_mulai: "",
    tanggal_selesai: "",
  });

  const [uploadedFiles, setUploadedFiles] = useState({
    laporan_kegiatan: null,
    dokumentasi: null,
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [ormasList, setOrmasList] = useState([]);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      logoutUser(props.history);
    } else {
      fetchOrmasList();
    }
  }, [props.history]);

  const fetchOrmasList = async () => {
    try {
      const response = await axios.get(`${API_MAI_FALI}ormas`);
      if (response.data.success) {
        setOrmasList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching ORMAS list:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileUpload = (e, field) => {
    const file = e.target.files[0];
    setUploadedFiles((prev) => ({
      ...prev,
      [field]: file,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const formDataToSend = new FormData();

      // Append form data
      Object.keys(formData).forEach((key) => {
        formDataToSend.append(key, formData[key]);
      });

      // Append files
      Object.keys(uploadedFiles).forEach((key) => {
        if (uploadedFiles[key]) {
          formDataToSend.append(key, uploadedFiles[key]);
        }
      });

      const response = await axios.post(
        `${API_MAI_FALI}laporan-kegiatan`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        setSuccess(true);
        setFormData({
          ormas_id: "",
          nama_kegiatan: "",
          bidang_kegiatan: "",
          sumber_anggaran: "",
          deskripsi_kegiatan: "",
          periode_kegiatan: "",
          lokasi_kegiatan: "",
          jumlah_peserta: "",
          anggaran_kegiatan: "",
          tanggal_mulai: "",
          tanggal_selesai: "",
        });
        setUploadedFiles({
          laporan_kegiatan: null,
          dokumentasi: null,
        });
      }
    } catch (error) {
      setError("Terjadi kesalahan saat menyimpan data. Silakan coba lagi.");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const bidangKegiatanOptions = [
    { value: "Pendidikan", label: "Pendidikan" },
    { value: "Kesehatan", label: "Kesehatan" },
    { value: "Ekonomi", label: "Ekonomi" },
    { value: "Sosial", label: "Sosial" },
    { value: "Budaya", label: "Budaya" },
    { value: "Lingkungan", label: "Lingkungan" },
    { value: "Politik", label: "Politik" },
    { value: "Agama", label: "Agama" },
    { value: "Lainnya", label: "Lainnya" },
  ];

  const sumberAnggaranOptions = [
    { value: "APBN", label: "APBN" },
    { value: "APBD", label: "APBD" },
    { value: "Swadaya", label: "Swadaya" },
    { value: "Donatur", label: "Donatur" },
    { value: "Kerjasama", label: "Kerjasama" },
    { value: "Lainnya", label: "Lainnya" },
  ];

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  <i className="tim-icons icon-chart-pie-36 text-primary" />
                  Pelaporan Kegiatan ORMAS
                </CardTitle>
                <p className="text-muted">
                  Laporkan kegiatan yang telah dilaksanakan oleh Organisasi
                  Kemasyarakatan sesuai dengan program kerja yang telah
                  direncanakan.
                </p>
              </CardHeader>
              <CardBody>
                {success && (
                  <Alert color="success">
                    Data pelaporan kegiatan berhasil disimpan!
                  </Alert>
                )}

                {error && <Alert color="danger">{error}</Alert>}

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Pilih ORMAS *</Label>
                        <Input
                          type="select"
                          name="ormas_id"
                          value={formData.ormas_id}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Pilih Organisasi</option>
                          {ormasList.map((ormas) => (
                            <option key={ormas.id} value={ormas.id}>
                              {ormas.nama_organisasi}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Nama Kegiatan *</Label>
                        <Input
                          type="text"
                          name="nama_kegiatan"
                          value={formData.nama_kegiatan}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Bidang Kegiatan *</Label>
                        <Input
                          type="select"
                          name="bidang_kegiatan"
                          value={formData.bidang_kegiatan}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Pilih Bidang Kegiatan</option>
                          {bidangKegiatanOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Sumber Anggaran *</Label>
                        <Input
                          type="select"
                          name="sumber_anggaran"
                          value={formData.sumber_anggaran}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Pilih Sumber Anggaran</option>
                          {sumberAnggaranOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Tanggal Mulai *</Label>
                        <Input
                          type="date"
                          name="tanggal_mulai"
                          value={formData.tanggal_mulai}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Tanggal Selesai *</Label>
                        <Input
                          type="date"
                          name="tanggal_selesai"
                          value={formData.tanggal_selesai}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Lokasi Kegiatan *</Label>
                        <Input
                          type="text"
                          name="lokasi_kegiatan"
                          value={formData.lokasi_kegiatan}
                          onChange={handleInputChange}
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Jumlah Peserta</Label>
                        <Input
                          type="number"
                          name="jumlah_peserta"
                          value={formData.jumlah_peserta}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Anggaran Kegiatan</Label>
                        <Input
                          type="number"
                          name="anggaran_kegiatan"
                          value={formData.anggaran_kegiatan}
                          onChange={handleInputChange}
                          placeholder="Rp"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Periode Kegiatan</Label>
                        <Input
                          type="text"
                          name="periode_kegiatan"
                          value={formData.periode_kegiatan}
                          onChange={handleInputChange}
                          placeholder="Contoh: Januari-Maret 2024"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <FormGroup>
                    <Label>Deskripsi Kegiatan *</Label>
                    <Input
                      type="textarea"
                      name="deskripsi_kegiatan"
                      value={formData.deskripsi_kegiatan}
                      onChange={handleInputChange}
                      rows="4"
                      required
                    />
                  </FormGroup>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Laporan Kegiatan (PDF)</Label>
                        <Input
                          type="file"
                          accept=".pdf"
                          onChange={(e) =>
                            handleFileUpload(e, "laporan_kegiatan")
                          }
                        />
                        <small className="text-muted">
                          Upload laporan kegiatan dalam format PDF
                        </small>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Dokumentasi Kegiatan</Label>
                        <Input
                          type="file"
                          accept=".jpg,.jpeg,.png,.pdf"
                          multiple
                          onChange={(e) => handleFileUpload(e, "dokumentasi")}
                        />
                        <small className="text-muted">
                          Upload foto atau dokumen dokumentasi kegiatan
                        </small>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="12" className="text-right">
                      <Button
                        type="button"
                        color="secondary"
                        className="mr-2"
                        onClick={() => props.history.push("/data-ormas")}
                      >
                        Batal
                      </Button>
                      <Button type="submit" color="primary" disabled={loading}>
                        {loading ? "Menyimpan..." : "Simpan Laporan Kegiatan"}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PelaporanKegiatan;
